import { m } from 'framer-motion'
import { Award, BookOpen, TrendingUp } from 'lucide-react'

import { staggerContainer, fadeUpItem, viewportConfig } from '../lib/motion-variants'

const features = [
  {
    Icon: TrendingUp,
    text: '+15 anos em crédito empresarial e reestruturação financeira',
  },
  {
    Icon: Award,
    text: 'MBA em Gestão Financeira',
  },
  {
    Icon: BookOpen,
    text: 'Autor & criador do Método SDS Empresarial®',
  },
]

export function FeaturesBar() {
  return (
    <section className="bg-primary py-10">
      <div className="mx-auto max-w-[1140px] px-4 md:px-6 lg:px-8">
        <m.div
          className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0"
          variants={staggerContainer}
          initial="initial"
          whileInView="whileInView"
          viewport={viewportConfig}
        >
          {features.map(({ Icon, text }, i) => (
            <m.div
              key={text}
              variants={fadeUpItem}
              className="flex items-center gap-4 md:px-8 relative"
            >
              {/* Divisor vertical entre colunas */}
              {i > 0 && (
                <span
                  className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 h-12 w-px bg-white/20"
                  aria-hidden
                />
              )}

              {/* Ícone dourado */}
              <div className="flex-shrink-0 w-16 h-16 rounded-xl bg-ink-strong border border-gold/40 flex items-center justify-center shadow-[0_4px_16px_rgba(0,0,0,0.25)]">
                <Icon size={32} className="text-gold" strokeWidth={2} />
              </div>

              {/* Texto */}
              <p className="text-white font-semibold text-sm md:text-base leading-snug">{text}</p>
            </m.div>
          ))}
        </m.div>
      </div>
    </section>
  )
}
